// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-chat-window {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.custom-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
}

.custom-icon {
  width: 56px;
  height: 56px;
  padding: 6px 8px;
  background: #e6f4ff;
  border: 1px solid #85a5ff;
  border-radius: 60px;
}

.custom-heading {
  text-align: center;
  font-size: 1.2rem;
  font-weight: 500;
}
/* not using this */
/* .chat-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 600px;
  margin: 0 auto;
  padding: 16px;
} */

.chat-input-icon {
  font-size: 18px;
  color: #999;
  cursor: pointer;
}

.chat-input {
  flex: 1;
  border-radius: 20px;
  height: 40px;
  text-align: left;
}

.send-icon {
  font-size: 18px;
  color: #999;
  cursor: pointer;
}

.button-row {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 20px;
}

.chat-button {
  display: flex;
  align-items: baseline;
  gap: 6px;
  border-radius: 8px;
}
.chat-input-wrapper {
  display: flex;
  align-items: flex-end;
  padding: 10px 0px;
  background-color: #fff;
  gap: 8px;
  text-align: left;
  width: 100%;
  flex-shrink: 0;
}
.new-chat-window .new-chat-window-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: auto;
}

.chat-input {
  flex: 1;
  resize: none;
  border: 1px solid #ddd;
  padding: 15px;
  font-size: 16px;
  border-radius: 8px;
  background-color: #f9f9f9;
  outline: none;
  text-align: left;
}

.send-icon-button {
  color: #1890ff;
  font-size: 18px;
}
.chat-input::placeholder {
  text-align: left;
}
.attached-files {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0 0 12px;
}

.inline-file-pill {
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  padding: 4px 10px;
  font-size: 12px;
  white-space: nowrap;
}

.attach-btn-wrapper {
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.plus-icon-button {
  width: 28px;
  height: 28px;
  background-color: #f5f5f5;
  border-radius: 50%;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
}

.plus-icon-button:hover {
  background-color: #e6e6e6;
}

.custom-dropdown {
  background: white;
  border-radius: 8px;
  min-width: 260px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.dropdown-item {
  align-items: center;
  padding: 10px;
  cursor: pointer;
  position: relative;
  gap: 8px;
  display: flex;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

/* .dropdown-item span {
  margin-left: 8px;
  flex: 1;
} */

.submenu-container {
  position: absolute;
  left: 100%;
  top: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 8px;
  width: 280px;
  z-index: 10;
}

.doc-submenu {
  display: flex;
  flex-direction: column;
  padding-right: 10px;
}

.doc-search-input {
  margin-bottom: 8px;
  border-radius: 6px;
  padding-left: 5px;
}

.doc-list {
  margin-top: 2px;
  overflow: auto;
  max-height: 160px;
  padding-right: 10px;
}

.doc-item {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: 4px;
  gap: 8px;
}

.doc-item:hover {
  background-color: #f0f0f0;
}

.doc-icon {
  margin-right: 8px;
  font-size: 16px;
}

.doc-more {
  padding: 6px 10px;
  color: #999;
  font-size: 13px;
  cursor: default;
}
.submenu-arrow {
  font-size: 12px;
}

.inline-attached-files {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 6px;
}
.chat-input-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.dropdown-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ai-processing-simple-stepper {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.ai-simple-step-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 32px;
  position: relative;
}

.ai-simple-step-dot-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  position: relative;
  width: 16px;
  height: 32px;
}

.ai-simple-step-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #bdbdbd;
  margin: 0;
  transition:
    background 0.3s,
    box-shadow 0.3s;
  flex-shrink: 0;
  z-index: 2;
  box-shadow: 0 0 0 0 #1890ff00;
}

.ai-simple-step-dot.active {
  background: #1890ff;
  box-shadow: 0 0 0 2px #1890ff33;
}

.ai-simple-step-dot.completed {
  background: #bdbdbd;
}

.ai-simple-step-line {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%) scaleY(1);
  width: 2px;
  height: 100%;
  background: #e0e0e0;
  z-index: 1;
}

.ai-simple-step-line.active {
  transform: translateX(-50%) scaleY(0);
  animation: growLine 1s ease-in forwards;
}

@keyframes growLine {
  from {
    transform: translateX(-50%) scaleY(0);
  }
  to {
    transform: translateX(-50%) scaleY(1);
  }
}

.ai-simple-step-text {
  color: #bdbdbd;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.6;
  padding: 0;
  margin: 0;
  transition: color 0.3s;
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Ai/components/MainChatAiWindow.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA,mBAAmB;AACnB;;;;;;;GAOG;;AAEH;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT;;mBAEiB;EACjB,cAAc;EACd,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,qCAAqC;EACrC,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".new-chat-window {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.custom-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.custom-icon {\n  width: 56px;\n  height: 56px;\n  padding: 6px 8px;\n  background: #e6f4ff;\n  border: 1px solid #85a5ff;\n  border-radius: 60px;\n}\n\n.custom-heading {\n  text-align: center;\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n/* not using this */\n/* .chat-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 16px;\n} */\n\n.chat-input-icon {\n  font-size: 18px;\n  color: #999;\n  cursor: pointer;\n}\n\n.chat-input {\n  flex: 1;\n  border-radius: 20px;\n  height: 40px;\n  text-align: left;\n}\n\n.send-icon {\n  font-size: 18px;\n  color: #999;\n  cursor: pointer;\n}\n\n.button-row {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 20px;\n}\n\n.chat-button {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  border-radius: 8px;\n}\n.chat-input-wrapper {\n  display: flex;\n  align-items: flex-end;\n  padding: 10px 0px;\n  background-color: #fff;\n  gap: 8px;\n  text-align: left;\n  width: 100%;\n  flex-shrink: 0;\n}\n.new-chat-window .new-chat-window-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: auto;\n}\n\n.chat-input {\n  flex: 1;\n  resize: none;\n  border: 1px solid #ddd;\n  padding: 15px;\n  font-size: 16px;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  outline: none;\n  text-align: left;\n}\n\n.send-icon-button {\n  color: #1890ff;\n  font-size: 18px;\n}\n.chat-input::placeholder {\n  text-align: left;\n}\n.attached-files {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 8px 0 0 12px;\n}\n\n.inline-file-pill {\n  background-color: #f5f5f5;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  padding: 4px 10px;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.attach-btn-wrapper {\n  display: flex;\n  align-items: center;\n  margin-right: 8px;\n}\n.plus-icon-button {\n  width: 28px;\n  height: 28px;\n  background-color: #f5f5f5;\n  border-radius: 50%;\n  border: 1px solid #d9d9d9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.plus-icon-button:hover {\n  background-color: #e6e6e6;\n}\n\n.custom-dropdown {\n  background: white;\n  border-radius: 8px;\n  min-width: 260px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.dropdown-item {\n  align-items: center;\n  padding: 10px;\n  cursor: pointer;\n  position: relative;\n  gap: 8px;\n  display: flex;\n}\n\n.dropdown-item:hover {\n  background-color: #f5f5f5;\n}\n\n/* .dropdown-item span {\n  margin-left: 8px;\n  flex: 1;\n} */\n\n.submenu-container {\n  position: absolute;\n  left: 100%;\n  top: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  padding: 8px;\n  width: 280px;\n  z-index: 10;\n}\n\n.doc-submenu {\n  display: flex;\n  flex-direction: column;\n  padding-right: 10px;\n}\n\n.doc-search-input {\n  margin-bottom: 8px;\n  border-radius: 6px;\n  padding-left: 5px;\n}\n\n.doc-list {\n  margin-top: 2px;\n  overflow: auto;\n  max-height: 160px;\n  padding-right: 10px;\n}\n\n.doc-item {\n  display: flex;\n  align-items: center;\n  padding: 6px 10px;\n  cursor: pointer;\n  border-radius: 4px;\n  gap: 8px;\n}\n\n.doc-item:hover {\n  background-color: #f0f0f0;\n}\n\n.doc-icon {\n  margin-right: 8px;\n  font-size: 16px;\n}\n\n.doc-more {\n  padding: 6px 10px;\n  color: #999;\n  font-size: 13px;\n  cursor: default;\n}\n.submenu-arrow {\n  font-size: 12px;\n}\n\n.inline-attached-files {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n.chat-input-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.dropdown-item.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ai-processing-simple-stepper {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.ai-simple-step-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  min-height: 32px;\n  position: relative;\n}\n\n.ai-simple-step-dot-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  position: relative;\n  width: 16px;\n  height: 32px;\n}\n\n.ai-simple-step-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #bdbdbd;\n  margin: 0;\n  transition:\n    background 0.3s,\n    box-shadow 0.3s;\n  flex-shrink: 0;\n  z-index: 2;\n  box-shadow: 0 0 0 0 #1890ff00;\n}\n\n.ai-simple-step-dot.active {\n  background: #1890ff;\n  box-shadow: 0 0 0 2px #1890ff33;\n}\n\n.ai-simple-step-dot.completed {\n  background: #bdbdbd;\n}\n\n.ai-simple-step-line {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%) scaleY(1);\n  width: 2px;\n  height: 100%;\n  background: #e0e0e0;\n  z-index: 1;\n}\n\n.ai-simple-step-line.active {\n  transform: translateX(-50%) scaleY(0);\n  animation: growLine 1s ease-in forwards;\n}\n\n@keyframes growLine {\n  from {\n    transform: translateX(-50%) scaleY(0);\n  }\n  to {\n    transform: translateX(-50%) scaleY(1);\n  }\n}\n\n.ai-simple-step-text {\n  color: #bdbdbd;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1.6;\n  padding: 0;\n  margin: 0;\n  transition: color 0.3s;\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
